import $ from 'jquery'
import { httpGet, httpPost, httpDelete, httpPut } from '../Util/http';
import { addAlert } from '../MsgNotify/msgNotifyActions';
import stripSuggestions from '../Util/stripSuggestions';
import { crewRates, withMissingCrewRates } from './constants'

function preventBack(dispatch) {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
        dispatch(addAlert('Husk at gemme eller fortryde dine ændringer'))
        window.history.go(1);
        dispatch({ type: 'BLINK' })
    };
    $(window).on('beforeunload', function () {
        return 'You haven\'t saved your changes.';
    });
}

function enableBack() {
    $(window).off('beforeunload');
    window.onpopstate = () => { }
    // window.history.back();
    // window.history.pushState(null, null, window.location.href);

}

export const GET_CUSTOM_PRICELISTS = 'GET_CUSTOM_PRICELISTS';
export const getCustomPricelistsRequest = () => {
    return {
        type: GET_CUSTOM_PRICELISTS,
    }
}

export const SET_CREWRATES_LOADING = 'SET_CREWRATES_LOADING'
export const setCrewRatesLoading = (status) => {
    return {
        type: SET_CREWRATES_LOADING,
        status: status
    }
}

export const GET_CUSTOM_PRICELISTS_SUCCESS = 'GET_CUSTOM_PRICELISTS_SUCCESS';
export const getCustomPricelistsSuccess = (customPricelists) => {
    return {
        type: GET_CUSTOM_PRICELISTS_SUCCESS,
        customPricelists
    }
}

export const MARK_PRICELIST_SELECTED = 'MARK_PRICELIST_SELECTED';
export const markPricelistSelected = (index) => {
    return {
        type: MARK_PRICELIST_SELECTED,
        index
    }
}

export const CREATE_NEW_MODE = 'CREATE_NEW_MODE';
export const createNew = () => {
    return (dispatch) => {
        preventBack(dispatch)
        dispatch({
            type: CREATE_NEW_MODE,
        })
    }
}

export const COPY_MODE = 'COPY_MODE';
export const createCopy = () => {

    return (dispatch, getState) => {
        dispatch({ type: COPY_MODE })
        preventBack(dispatch)
        const index = getState().customPricelistReducer.selected;
        const name = getState().customPricelistReducer.customPricelists[index].name;
        dispatch(changeNewName(`Kopi af ${name}`))
    }
}


export const EDIT_MODE = 'EDIT_MODE';
export const edit = () => {
    return (dispatch, getState) => {
        preventBack(dispatch)
        dispatch({ type: EDIT_MODE })
        const index = getState().customPricelistReducer.selected;
        const name = getState().customPricelistReducer.customPricelists[index].name;
        dispatch(changeNewName(`${name}`))
    }
}

export const productDiscountsBeforeEdit = () => {
    return (dispatch, getState) => {
        const be = getState().customPricelistReducer.productDiscountsBeforeEdit
        dispatch(setProductDiscounts(be))
    }
}

export const CANCEL_CREATE_MODE = 'CANCEL_CREATE_MODE';
export const cancelCreate = () => {
    return (dispatch) => {
        enableBack()
        dispatch({
            type: CANCEL_CREATE_MODE,
        })
    }
}

export const cancelCreateButton = () => {
    return (dispatch, getState) => {
        dispatch(cancelCreate())
        dispatch(setOffersLoading(true))
        dispatch(setCrewRatesLoading(true))
        const index = getState().customPricelistReducer.selected;
        const id = getState().customPricelistReducer.customPricelists[index].customPricelistId

        getOffers(id)
            .then((content) => dispatch(updateOffers(content)))
            .then(() => dispatch(setOffersLoading(false)))

        httpGet(process.env.REACT_APP_productCatalogEndPoint + `api/crewrates?id=${id}`)
            .then((res) => res.json())
            .then((data) => {
                dispatch({
                    type: SET_CREWRATES,
                    crewRates: withMissingCrewRates(JSON.parse(data))
                })
            })
            .then(() => dispatch(setCrewRatesLoading(false)))
            .catch(() => {
                //doesnt exists
                let c = JSON.parse(JSON.stringify(crewRates))
                dispatch({
                    type: SET_CREWRATES,
                    crewRates: c
                })
                dispatch(setCrewRatesLoading(false))
            })
    }
}

export const DELETE_CUSTOM_PRICELIST_MODE = 'DELETE_CUSTOM_PRICELIST_MODE';
export const deleteMode = () => {
    return (dispatch) => {
        preventBack(dispatch)
        dispatch({
            type: DELETE_CUSTOM_PRICELIST_MODE,
        })
    }
}

export const CREATE_REQUEST_LOADING = 'CREATE_REQUEST_LOADING';
export const createRequestLoading = (status) => {
    return {
        type: CREATE_REQUEST_LOADING,
        status,
    }
}

export const SET_CUSTOMPRICELISTS_LOADING = 'SET_CUSTOMPRICELISTS_LOADING';
export const setCustomPricelistsLoading = (status) => {
    return {
        type: SET_CUSTOMPRICELISTS_LOADING,
        status,
    }
}

export const SET_PRODUCTDISCOUNTS_LOADING = 'SET_PRODUCTDISCOUNTS_LOADING';
export const setProductDiscountsLoading = (status) => {
    return {
        type: SET_PRODUCTDISCOUNTS_LOADING,
        status,
    }
}

export const SET_OFFERS_LOADING = 'SET_OFFERS_LOADING';
export const setOffersLoading = (status) => {
    return {
        type: SET_OFFERS_LOADING,
        status,
    }
}

export const DELETE_REQUEST_LOADING = 'DELETE_REQUEST_LOADING';
export const deleteRequestLoading = (status) => {
    return {
        type: DELETE_REQUEST_LOADING,
        status,
    }
}

export const ADD_CUSTOM_PRICELIST = 'ADD_CUSTOM_PRICELIST';
export const addCustomPricelist = (id, name) => {
    return {
        type: ADD_CUSTOM_PRICELIST,
        id,
        name,
    }
}

export const EDIT_CUSTOM_PRICELIST_NAME = 'EDIT_CUSTOM_PRICELIST_NAME';
export const updateCustomPricelistName = (index, name) => {
    return {
        type: EDIT_CUSTOM_PRICELIST_NAME,
        index,
        name,
    }
}

export const ONCHANGE_NEW_PRICELIST_NAME = 'ONCHANGE_NEW_PRICELIST_NAME';
export const changeNewName = (name) => {
    return {
        type: ONCHANGE_NEW_PRICELIST_NAME,
        name,
    }
}

export const REMOVE_CUSTOM_PRICE_LIST = 'REMOVE_CUSTOM_PRICE_LIST';
export const removeCustomPricelist = (index) => {
    return {
        type: REMOVE_CUSTOM_PRICE_LIST,
        index,
    }
}

export const UPDATE_OFFERS = 'UPDATE_OFFERS';
export const updateOffers = (offers) => {
    return {
        type: UPDATE_OFFERS,
        offers,
    }
}

export const PUSH_OFFERS = 'PUSH_OFFERS';
export const pushOffers = (offers) => {
    return {
        type: PUSH_OFFERS,
        offers,
    }
}


export const PRODUCT_SUGGESTIONS_SUCCESS = 'PRODUCT_SUGGESTIONS_SUCCESS';
export const getUsageSuggestionsSuccess = (suggestions) => {
    suggestions.forEach((s) => {
        s.id = s.productId
    });
    return (
        {
            type: PRODUCT_SUGGESTIONS_SUCCESS,
            suggestions: suggestions
        }
    )
}

export const ADD_PRODUCT_TO_DISCOUNT_LIST = 'ADD_PRODUCT_TO_DISCOUNT_LIST';
export const addProductToDiscountList = (product) => {
    return ({
        type: ADD_PRODUCT_TO_DISCOUNT_LIST,
        product
    })
}

export const SET_DISCOUNT_LIST = 'SET_DISCOUNT_LIST';
export const setProductDiscounts = (discounts) => {
    return ({
        type: SET_DISCOUNT_LIST,
        discounts
    })
}

export const UPDATE_DISCOUNT_PRICE = 'UPDATE_DISCOUNT_PRICE'
export const updateDiscount = (index, val) => {
    return ({
        type: UPDATE_DISCOUNT_PRICE,
        index,
        val
    })
}

export const REMOVE_DISCOUNT_PRICE = 'REMOVE_DISCOUNT_PRICE'
export const removeDiscount = (index) => {
    return ({
        type: REMOVE_DISCOUNT_PRICE,
        index,
    })
}

export const REMOVE_ALL_DISCOUNTS = 'REMOVE_ALL_DISCOUNTS'
export const removeAllDiscounts = () => {
    return ({
        type: REMOVE_ALL_DISCOUNTS,
    })
}


export const getCustomPricelists = () => {
    return (dispatch) => {
        const url = process.env.REACT_APP_productCatalogEndPoint + `api/custompricelist`;
        dispatch(getCustomPricelistsRequest())
        return httpGet(url)
            .then((resp) => resp.json())
            .then((p) => dispatch(getCustomPricelistsSuccess(p.customPricelists)))
            .then(() => dispatch(setCustomPricelistsLoading(false)))
            .catch(() => {
                dispatch(addAlert('Kunne ikke hente særprislister'))
                dispatch(setCustomPricelistsLoading(false))
            })
    }
}

function getProductDiscounts(id) {
    const url = process.env.REACT_APP_productCatalogEndPoint + `api/productdiscounts/${id}`;
    return httpGet(url)
        .then((rsp) => rsp.json())
}

function getOffers(id) {
    const url = process.env.REACT_APP_productCatalogEndPoint + `api/offers/${id}`;
    return httpGet(url)
        .then((rsp) => rsp.json())
}

export const selectCustomPricelist = (index, force = false) => {
    return (dispatch, getState) => {
        const selected = getState().customPricelistReducer.selected;
        if (selected === index && !force) {
            index = "johnmogensen"
            dispatch(updateOffers([]))
            dispatch(removeAllDiscounts())
            dispatch(markPricelistSelected(index))
        } else {
            dispatch(markPricelistSelected(index))
            const name = getState().customPricelistReducer.customPricelists[index].name
            const id = getState().customPricelistReducer.customPricelists[index].customPricelistId
            dispatch(changeNewName(name))
            dispatch(setProductDiscountsLoading(true))
            dispatch(setOffersLoading(true))
            dispatch(setCrewRatesLoading(true))

            getProductDiscounts(id)
                .then((content) => dispatch(setProductDiscounts(content)))
                .then(() => dispatch(setProductDiscountsLoading(false)))
            getOffers(id)
                .then((content) => dispatch(updateOffers(content)))
                .then(() => dispatch(setOffersLoading(false)))

            httpGet(process.env.REACT_APP_productCatalogEndPoint + `api/crewrates?id=${id}`)
                .then((res) => res.json())
                .then((data) => {
                    dispatch({
                        type: SET_CREWRATES,
                        crewRates: withMissingCrewRates(JSON.parse(data))
                    })
                })
                .then(() => dispatch(setCrewRatesLoading(false)))
                .catch(() => {
                    //doesnt exists
                    let c = JSON.parse(JSON.stringify(crewRates))
                    dispatch({
                        type: SET_CREWRATES,
                        crewRates: c
                    })
                    dispatch(setCrewRatesLoading(false))
                })

        }
    }
}
export const SET_CREWRATES = 'SET_CREWRATES'

export const UPDATE_EMPLOYEE_FUNCTION_ROW = 'custompricelist/UPDATE_EMPLOYEE_FUNCTION_ROW'
export const updateEmployeeFunction = (fun, object) => {
    return {
        type: UPDATE_EMPLOYEE_FUNCTION_ROW,
        fun,
        object
    }
}

function sleep(seconds) {
    var e = new Date().getTime() + (seconds * 1000);
    while (new Date().getTime() <= e) {
        // empty linter fucker
    }
}

export const deleteCustomPricelist = () => {
    return (dispatch, getState) => {
        dispatch(deleteRequestLoading(true))
        const index = getState().customPricelistReducer.selected;
        const id = getState().customPricelistReducer.customPricelists[index].customPricelistId;
        const url = process.env.REACT_APP_productCatalogEndPoint + `api/custompricelist/${id}`;
        return httpDelete(url)
            .then(() => sleep(1))
            .then(() => dispatch(deleteRequestLoading(false)))
            .then(() => dispatch(cancelCreate()))
            .then(() => dispatch(removeCustomPricelist(index)))
            .then(() => dispatch(selectCustomPricelist(index)))
            .then(() => dispatch(changeNewName('')))
            .catch(() => {
                sleep(1)
                dispatch(addAlert('Kunne ikke slette særprisliste'))
                dispatch(deleteRequestLoading(false))
            })
    }
}

function editCustomPricelistNameRequest(id, name) {
    const url = process.env.REACT_APP_productCatalogEndPoint + `api/custompricelist`;
    return httpPut(url, { id: id, name: name })
}
function updateProductDiscounts(id, discounts) {
    const url = process.env.REACT_APP_productCatalogEndPoint + `api/productdiscounts`;
    const mapped = discounts.map((d) => {
        if (d.productId) { d.id = d.productId }
        return {
            productId: d.id,
            discountPrice: d.discount
        }
    })
    return httpPut(url, { id, productDiscounts: mapped })
}

function NoneEmpty(arr) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] !== "") {
            return true
        }
    }
    return false;
}

function updateOffersRequest(id, offers) {
    const url = process.env.REACT_APP_productCatalogEndPoint + `api/offers`;
    const mapped = offers.map((d) => {
        return {
            posNr: d[0],
            posName: d[1],
            unit: d[2],
            amount: d[3],
            price: d[4],
            sum: d[5],
            description: d[6],
        }
    })
    return httpPut(url, { id, offers: mapped })
}

export const submit = (offers) => {
    return (dispatch, getState) => {
        const mode = getState().customPricelistReducer.mode;
        const url = process.env.REACT_APP_productCatalogEndPoint + `api/custompricelist`;
        const name = getState().customPricelistReducer.newName;
        const discs = getState().customPricelistReducer.productDiscounts

        let filteredOffers = []
        offers.forEach((o) => {
            if (NoneEmpty(o)) {
                filteredOffers.push(o)
            }
        })
        dispatch(createRequestLoading(true))
        dispatch(updateOffers(filteredOffers))


        if (mode === 'edit') {
            const index = getState().customPricelistReducer.selected;
            const id = getState().customPricelistReducer.customPricelists[index].customPricelistId;

            return editCustomPricelistNameRequest(id, name)
                .then(() => updateProductDiscounts(id, discs))
                .then(() => updateOffersRequest(id, filteredOffers))
                .then(() => dispatch(updateCustomPricelistName(index, name)))
                .then(() => {
                    return httpPost(process.env.REACT_APP_productCatalogEndPoint + `api/crewrates`,
                        {
                            id: id,
                            data: JSON.stringify(getState().customPricelistReducer.crewRates)
                        })
                        .catch((e) => {
                            console.log(e)
                            alert('kunne ikke gemme mandskab')
                        })
                })
                .then(() => sleep(1))
                .then(() => dispatch(createRequestLoading(false)))
                .then(() => dispatch(cancelCreate()))
                .then(() => dispatch(changeNewName('')))
                .catch(() => {
                    sleep(2)
                    dispatch(addAlert('Kunne ikke redigere særprisliste'))
                    dispatch(createRequestLoading(false))
                })
        } else {
            return httpPost(url, { name: name })
                .then((resp) => resp.json())
                .then((id) => {
                    updateProductDiscounts(id, discs)
                    updateOffersRequest(id, offers)
                    return id
                })
                .then((id) => {
                    dispatch(addCustomPricelist(id, name))
                    return id
                })
                .then((id) => {
                    return httpPost(process.env.REACT_APP_productCatalogEndPoint + `api/crewrates`,
                        {
                            id: id,
                            data: JSON.stringify(getState().customPricelistReducer.crewRates)
                        })
                        .catch((e) => {
                            console.log(e)
                            alert('kunne ikke gemme mandskab')
                        })
                })
                .then(() => sleep(1))
                .then(() => dispatch(createRequestLoading(false)))
                .then(() => dispatch(cancelCreate()))
                .then(() => dispatch(changeNewName('')))
                .then(() => dispatch(markPricelistSelected(0)))
                .catch(() => {
                    sleep(2)
                    dispatch(addAlert('Kunne ikke gemme særprisliste'))
                    dispatch(createRequestLoading(false))
                })
        }
    }
}

export const getProductSuggestions = (val) => {
    var fetchUrl = process.env.REACT_APP_productCatalogEndPoint + "api/product?search=" + val + "&skip=0&take=5"
    return (dispatch, getState) => {
        if (!val) {
            dispatch(getUsageSuggestionsSuccess([]))
            return;
        }
        return httpGet(fetchUrl)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                let alreadyChosen = getState().customPricelistReducer.productDiscounts;
                var jsonReponse = stripSuggestions(json, alreadyChosen)
                dispatch(getUsageSuggestionsSuccess(jsonReponse))
            })
            .catch((e) => {
                console.log(e);
            })
    };
}




// WEBPACK FOOTER //
// ./src/App/CustomPricelist/actions.js